// extracted by mini-css-extract-plugin
export default {"alert":"UserComments_alert__ammpl","pulse":"UserComments_pulse__ZtNBP"};